<template>
  <v-dialog persistent
            @keydown.esc="closeButton"
            @keydown.enter="enterPressed"
            :value="showDialog"
            :content-class="customClasses">
    <v-layout column>
      <header class="vc-general-dialog-header">
        <slot name="header"></slot>
      </header>
      <div class="vc-general-dialog-content">
          <slot class="dialog-content-inner" name="content"></slot>
      </div>
      <v-divider></v-divider>
      <footer :style="[direction == 'ltr' ? {direction:'rtl'} : {direction:'ltr'}]" class="vc-general-dialog-footer">
        <v-card-actions>
          <div class="vc-general-dialog-actions-container">
            <slot name="actions"></slot>
          </div>
        </v-card-actions>
      </footer>
    </v-layout>
  </v-dialog>
</template>
<script>

export default {
  props: ['showDialog','dialogClass'],
  name: "GeneralDialog",
  deprecated: "(GeneralDialog) - Please use DialogWrapper or DialogCmp instead",
  created() {
    let that = this;

    this.listener = function (e) {
      if (typeof e.data === "string" && e.data.indexOf("frontage-app") !== -1) {
        const post_data = JSON.parse(e.data);
        if (post_data.message === 'frontageNavAway'){
          that.closeButton()
        }
      }
    };

    window.addEventListener("message", this.listener)
    this.$store.commit("setDialogStatus", {isOpen:true})
    this.$frontageApi.send('open_modal')
  },
  destroyed(){
    window.removeEventListener("message", this.listener)
    this.$store.commit("setDialogStatus", {isOpen:false})
    this.$frontageApi.send('close_modal')
  },
  methods:{
    closeButton(){
      this.$emit("closeButtonPressed", false);
    },
    enterPressed(){
      this.$emit("enterPressed");
    }
  },
  computed:{
    direction(){
        return this.$store.getters.direction
    },
    customClasses() {
      let cls = 'vc-general-dialog'
      if (this.dialogClass) {
        cls += " " + this.dialogClass
      }

      return cls;
    },
  }
}
</script>
<style lang="scss">
@import "@/assets/scss/abstract/_variables.scss";
@import "@/assets/scss/abstract/_mixins.scss";

.vc-general-dialog{

  &.v-dialog {
    width: 570px;
    height: auto;
    min-height: 300px;
    background-color: #ffffff;
    box-shadow: $boxShadow;
    font-family: var(--font3);
    display: flex;
    border-radius: 4px;

    /* offset when opened in frontage layout iframe */
    position: relative;
    top: -40px;
    left: -112px;

    @include sm-and-down{
      /* offset when opened in frontage layout iframe */
      position: relative;
      top: 0px;
      left: 0px;
      height: 100%;
      margin: 0px;

      &:not(.v-dialog--fullscreen) {
        max-height: 100% !important;
        max-width: 570px;
        position: relative;
        width: 100%;
        height: 100vh;
        margin: 0;
      }
    }

    .vc-general-dialog-header{
      margin: 23px 0px 15px 0px;
      color: $color_dark_text;
      font-size: 24px;
      font-weight: 600;
      padding: 0px 30px;
    }

    .vc-general-dialog-content{
      overflow: auto;
      order:1;
      width: 100%;
      height: 100%;
      padding: 0px 30px;
      margin-bottom: 30px;

      @include sm-and-down{
        width: 100%;
        height: 100%;
        padding: 0px 20px;
      }
    }

    .v-divider{
      border-color:$dividerColor;
      display: flex;
      order: 2;
    }

    .vc-general-dialog-footer{
      display: flex;
      order: 3;
    }

    .v-chip.v-size--default {
      @include i-margin-mirror(0px,5px);
    }

    .vc-general-dialog-actions-container {
      padding: 15px;
    }

    .v-card__actions{
      padding: 0px;
      width: 100%;

      div{
        width: 100%;
        @include i-text-align(right);
      }

      button{
        color: $linkColor;
        font-weight: 600;
        font-size: 14px;
        margin: 5px;
        margin-top: 0;
        margin-bottom: 0;

        &:hover{
          background-color: $grey-color-7;
          border-radius: 2px;
        }

        &.disable{
          pointer-events: none;
          color: $actionDisable;
        }
      }
    }
  }
}
</style>

